import { sortedUniqBy } from 'lodash'
import _GTABLE from './gtable'
import { getValidValue } from './well-known-config'
const SAVED_FILE_PATH = './nxinface.config.json'
const SAVED_ENCRYPTED_FILE_PATH = './nxinface.enconfig.json'

let globalEnv = typeof window !== 'undefined' ? window : global
let database = {}

if (!globalEnv._inface_env) {
    globalEnv._inface_env = { INFACE_VERSION: 'no-set'}
}

export const GTABLE = _GTABLE

export const value = globalEnv._inface_env

export const DEVICE_TYPES = Object.freeze({
    BROWSER: 'BROWSER',
    DESKTOP: 'DESKTOP',
    MOBILE: 'MOBILE'
})

export function isBrowser() {
    return !!(typeof window === 'object' && window.HTMLBodyElement)
}

export function getCurrentPlatform() {
    const platformRawName = process.platform
    if (/android|ios/.test(platformRawName)) {
        return platformRawName
    } else if (/win/.test(platformRawName)) {
        return 'windows'
    } else if (/darwin/.test(platformRawName)) {
        return 'mac'
    }
    
    return platformRawName
}

/**
 * 게임을 위한 일반적인 플랫폼 분류 타입을 반환합니다
 *
 * @export
 * @return {string}  platform name desktop, android, ios, browser
 */
export function getGamePlatform() {
    const platformRawName = process.platform
    if (isBrowser()) {
        return 'browser'
    } else if (/android|ios/.test(platformRawName)) {
        return platformRawName
    }

    return 'desktop'
}

/**
 *
 *  device의 OS 정보를 포함한 기본정보를 리턴합니다
 *
 * @export
 * @return {Object}  { type: 'DESKTOP', arch: 'x64', platform: 'windows', platform_g: 'desktop'} or { type: 'MOBILE', arch: 'x64', platform: 'android', platform_g: 'android'}
 */
export function device() {
    const platform = getCurrentPlatform()
    const gamePlatform = getGamePlatform()
    const info = {
        type: isBrowser() ? DEVICE_TYPES.BROWSER : /android|ios/.test(process.platform) ? DEVICE_TYPES.MOBILE : DEVICE_TYPES.DESKTOP,
        arch: (isBrowser() ? navigator.platform : process.arch) || 'unknown',
        platform,
        platform_g: gamePlatform
    }
    return info
}

export function get(key) {
    return database[key]
}

export function set(key, value) {
    return database[key] = value
}

export async function save() {
    try {
        const serializedJSON = JSON.stringify(database)
        const encryptedText = _encrypt(serializedJSON)
        const deviceInfo = device()
        if (deviceInfo.type === DEVICE_TYPES.BROWSER) {
            const localStorage = window.localStorage
            localStorage.setItem(`enxinface_${location.host}`, encryptedText)
            localStorage.removeItem(`nxinface_${location.host}`)
        } else if (deviceInfo.type === DEVICE_TYPES.DESKTOP) {
            const fs = require('fs')
            
            fs.writeFileSync(SAVED_ENCRYPTED_FILE_PATH, encryptedText, 'utf8')
            if (fs.existsSync(SAVED_FILE_PATH)) {
                // 저장한뒤 암호화 안된 설정 파일 제거
                fs.unlinkSync(SAVED_FILE_PATH)
            }
        } else {
            throw new Error('does not support mobile save feather')
        }

    } catch (error) {
        return { status: false, error}
    }
    
    return { status: true }
}

function getObjectFromText(configText) {
    try {
        return JSON.parse(configText)
    } catch (e) {
        return {}
    }
}

function _encrypt(decryptedStr) {
    return Buffer.from(decryptedStr).toString('base64').split('').join('&')
}

export function encrypt(decryptedStr) {
    return isBrowser() ? window.btoa(decryptedStr) : _encrypt(decryptedStr)
}

function _decrypt(encryptedStr) {
    const decryptTextReady = encryptedStr.split('').filter((_, index) => !(index %2)).join('')
    return Buffer.from(decryptTextReady, 'base64').toString()
}

export function decrypt(encryptedStr) {
    return isBrowser() ? window.atob(encryptedStr) : _decrypt(encryptedStr)
}

export async function load() {
    try {
        const deviceInfo = device()
        if (deviceInfo.type === DEVICE_TYPES.BROWSER) {
            const localStorage = window.localStorage
            const decryptedStr = localStorage.getItem(`nxinface_${location.host}`)
            const configJSON = decryptedStr || _decrypt(localStorage.getItem(`enxinface_${location.host}`) || 'e30=') // ={}
            database = !!configJSON ? getObjectFromText(configJSON) : {}
        } else if (deviceInfo.type === DEVICE_TYPES.DESKTOP) {
            const fs = require('fs')
            const util = require('util')
            const readFile = util.promisify(fs.readFile)
            if (fs.existsSync(SAVED_FILE_PATH)) {
                const configJSON = await readFile(SAVED_FILE_PATH, 'utf8')
                database = !!configJSON ? getObjectFromText(configJSON) : {}
            } else if (fs.existsSync(SAVED_ENCRYPTED_FILE_PATH)) {
                const enConfigJSONTEXT = await readFile(SAVED_ENCRYPTED_FILE_PATH, 'utf8')
                const deConfigJSON = _decrypt(enConfigJSONTEXT)
                database = !!deConfigJSON ? getObjectFromText(deConfigJSON) : {}
            }
        } else {
            throw new Error('does not support mobile save feather')
        }

    } catch (error) {
        return { status: false, error }
    }
    
    return { status: true }
}

export function getAll() {
    return {...database}
}

export function namespace(_scopeName) {
    const scopeName = !!_scopeName ? `${_scopeName}.` : ''
    return {
        get: (key) => {
            return get(scopeName + key)
        },
        set: (key, value) => {
            return set(scopeName + key, value)
        },
        save: () => {
            return save()
        },
        load: () => {
            return load()
        },
        getAll: () => {
            return Object.keys(database)
                .filter(key => new RegExp(`^${scopeName}.`).test(key))
                .reduce((result, key) => {
                    result[key] = database[key]
                    return result
                }, {})
        }
    }
}


/**
 * INFACE Env GLOBAL Config.
 * 
 * @export
 * @param {object} environemnt
 */
 export function setupEnv(envs) {
    globalEnv._inface_env =  globalEnv._inface_env || { INFACE_VERSION: 'no-set'}
    Object.keys(envs).forEach(key => {
        globalEnv._inface_env[key] = getValidValue(key, envs[key])
        interfaceObject.value[key] = getValidValue(key, envs[key])
    })
}

const interfaceObject = {
    GTABLE,
    DEVICE_TYPES,
    value: globalEnv._inface_env,
    device,
    isBrowser,
    get,
    set,
    save,
    encrypt,
    decrypt,
    load,
    getAll,
    namespace,
    setupEnv
}

export default interfaceObject
